import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {fetchJackpots} from "./CasinoActions";

export const JackpotData = (props : {})  => {
    const dispatch = useDispatch();
    useEffect(()=>{
         dispatch(fetchJackpots() as any);
         let interval = setInterval(()=>{
             dispatch(fetchJackpots() as any);
         }, 5*60*1000);

        return () => {
             clearInterval(interval);
        }
    },[])
    return <></>
}